


























































































import { inject } from 'inversify-props';
import { Vue, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import IAuthService from '../.././services/IAuthService';
import ConsentService from '../../services/ConsentService';
import { ConsentSubscription} from '@models';

@Component
export default class ConsentDialog extends Vue {
  @inject() private authService: IAuthService;
  private consentItems: { id: number, title: string, htmlIsUrl: boolean, html: string, consentGranted: boolean }[] = [];
  private showConsentBox: boolean = false;
  private checkOnce: boolean = false;

  @Watch('$route')
  async routeChanged() {
    if (this.$route.matched.length > 0 && this.$route.matched[0].path === '/consent/details/:id') {
      return;
    }

    if (!this.isLoggedIn()) {
      this.showConsentBox = false;
    }
    else if (!this.checkOnce) {
      this.getConsentStatus().then().catch();
      this.checkOnce = true;
    }
  }

  public isLoggedIn() {
    return this.authService.getUser();
  }

  public async allConsentsChecked() {
    let count = 0;
    for (let i = 0; i < this.consentItems.length; i++) {
      if (this.consentItems[i].consentGranted === true) {
        count++;
      }
    }

    if (count === this.consentItems.length) {
      await this.addConsent();
      this.showConsentBox = false;
    }
  }

  public consentGranted() {
    let count = 0;
    for (let i = 0; i < this.consentItems.length; i++) {
      if (this.consentItems[i].consentGranted === true) {
        count++;
      }
    }

    if (count === this.consentItems.length) {
      return true;
    }
    return false;

  }

  public async addConsent() {
    let consentItemIds = this.consentItems.map((consentItem) => { return consentItem.id; });

    return await ConsentService.addConsentSubscriptions(consentItemIds)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  }

  async getConsentStatus() {
    if (this.showConsentBox) {
      return;
    }

    const requiredConsents = await ConsentService.getRequiredConsents()
      .then((response) => {
        return response.data as [];
      })
      .catch((error) => {
        console.error(error);
        return [];
      });

    const consentSubscriptions = await ConsentService.getSubscriptions()
      .then((response) => {
        return response.data as ConsentSubscription[];
      })
      .catch((error) => {
        return [];
      });

    while (this.consentItems.length > 0) {
      this.consentItems.pop();
    }

    requiredConsents.forEach((consentItem) => {
      const index = this.consentItems.push({ ...consentItem, consentGranted: false }) - 1;

      consentSubscriptions.forEach((sub) => { if (sub.consent.id == consentItem.id) { this.consentItems[index].consentGranted = true; } });
    });

    this.showConsentBox = !this.consentGranted();
  }

  // look for mutations in DOM tree
  onDomTreeChange(mutations: MutationRecord[]) {
    mutations.forEach((mutation) => {
      mutation.removedNodes.forEach((removedNode: HTMLElement) => {
        if (removedNode.id && removedNode.id == 'ConsentDialog' && this.showConsentBox) {
          const currentRoute = this.$router.currentRoute;
          window.location.replace(currentRoute.path);
        }
      });
    });
  }

  async mounted() {
    // init Mutation Observer
    let mutationObserver = new MutationObserver(this.onDomTreeChange);
    // observe target: site container inside app
    const mutationObserverTargetNode = document.querySelector('#app > div:first-child');
    // observe changes in DOM tree
    mutationObserver.observe(mutationObserverTargetNode, { childList: true, subtree: false });
  }
}
